// extracted by mini-css-extract-plugin
module.exports = {"root":"_2UsKD","withoutFooter":"nyec7","selectable":"_3qZBh"};